const researchData = {
  director: {
    id: 1,
    name: "Dr. C. Viswanatha Reddy",
    qualifications: "M.B.A., Ph.D.",
    position: "Director of Research Studies",
    department: "Professor and Head of Business Management",
    email: ["researchevaluation.ru@gmail.com", "directorresearch.ru@gmail.com"],
    phone: "9848263463",
    image: "/person/vishwanathareddy.jpg", // Place image in public/person/ folder
    office: "Directorate of Research Studies"
  }
};

export default researchData;